import { Box, Flex, Text } from '@chakra-ui/react';

import type { NotificationTabsProps } from './types/notification-tabs.props';

import { useNotificationTabsConfiguration } from './hooks/notification-tabs-configuration.hook';

export const NotificationTabs = ({ activeTab, counts, onChange }: NotificationTabsProps) => {
  const { onTabClick, tabs } = useNotificationTabsConfiguration(counts, onChange);

  return (
    <Flex
      borderBottom="1px solid"
      borderColor="gray.100"
      gap="4px"
      px="12px"
      py="8px">
      {tabs.map(({ count, key, label }) => {
        const isActive = activeTab === key;

        return (
          <Box
            _hover={isActive ? undefined : { bg: 'gray.100' }}
            alignItems="center"
            aria-selected={isActive}
            as="button"
            bg={isActive ? 'hsp.500' : 'transparent'}
            borderRadius="md"
            color={isActive ? 'white' : 'gray.600'}
            display="inline-flex"
            fontSize="12px"
            fontWeight="bold"
            gap="6px"
            key={key}
            onClick={() => {
              onTabClick(key);
            }}
            px="11px"
            py="6px"
            type="button">
            <Text
              as="span"
              color={isActive ? 'white' : 'gray.600'}>
              {label}
            </Text>
            <Box
              alignItems="center"
              bg={isActive ? 'whiteAlpha.300' : 'blackAlpha.200'}
              borderRadius="full"
              color="inherit"
              display="inline-flex"
              fontSize="10.5px"
              fontWeight="bold"
              h="17px"
              justifyContent="center"
              minW="17px"
              px="5px">
              {count}
            </Box>
          </Box>
        );
      })}
    </Flex>
  );
};
